var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { identificationType } from "../../store/identificationType/actions";
import { catalogGender } from "../../store/plan/actions";
import { PassengerFormHeader } from "./ui/header";
import { PassengerFormView } from "./ui/view";
import useSelectors from "./components/selectors";
import { useTranslation } from "react-i18next";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { useGetSummary } from "../../utils/getSummary";
import { getStepNavigation } from "../../utils/nextBackStep";
import { backStepByPath } from "../../utils/updateStepBack";
import { useGetInformationSteps } from "ah_utility/workflow";
import { useCompleteStep } from "../../utils/responseComplete";
import { updateStepByPath } from "ah_utility/workflow";
import { insertIntoStepInformation } from "../../utils/upsertStepInformation";
export var PassengerForm = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var externalEditingData = props.editingPassengerData, onSavePassenger = props.onSavePassenger, onCancel = props.onCancel;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var t = useTranslation().t;
    var rangoEdad1Count = React.useState(parseInt(findParamInLocalStorage("edad020")) || 0)[0];
    var rangoEdad2Count = React.useState(parseInt(findParamInLocalStorage("edad2174")) || 0)[0];
    var rangoEdad3Count = React.useState(parseInt(findParamInLocalStorage("edad7585")) || 0)[0];
    var totalPassengers = React.useState(rangoEdad1Count + rangoEdad2Count + rangoEdad3Count)[0];
    var _j = useState([]), filters = _j[0], setFilters = _j[1];
    var data = JSON.parse(localStorage.getItem('steps') || '[]');
    var origenViaje = (_d = (_c = (_b = (_a = data.find(function (step) { var _a; return (_a = step.details) === null || _a === void 0 ? void 0 : _a.origenViaje; })) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.origenViaje) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
    var destinoViaje = (_h = (_g = (_f = (_e = data.find(function (step) { var _a; return (_a = step.details) === null || _a === void 0 ? void 0 : _a.destinoViaje; })) === null || _e === void 0 ? void 0 : _e.details) === null || _f === void 0 ? void 0 : _f.destinoViaje) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '';
    var fechaSalida = React.useState(findParamInLocalStorage("fechaSalida") || "")[0];
    var fechaRegreso = React.useState(findParamInLocalStorage("fechaRegreso") || "")[0];
    var pathLocation = "/" + pathname.split("/")[1];
    // Local state
    var _k = useState([]), listGenders = _k[0], setListGenders = _k[1];
    var _l = useState([]), listIdentificationType = _l[0], setListIdentificationType = _l[1];
    var _m = useState(externalEditingData || null), editingPassengerData = _m[0], setEditingPassengerData = _m[1];
    var _o = useState([]), passengerList = _o[0], setPassengerList = _o[1];
    var dataNavigation = React.useState(getStepNavigation(pathname))[0];
    var enable = useState(true)[0];
    var page = useState(1)[0];
    var limit = useState(10000)[0];
    var _p = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _p[0], setSeeToast = _p[1];
    // Redux selectors
    var _q = useSelectors(), responseIdentificationType = _q.responseIdentificationType, loadingIdentificationType = _q.loadingIdentificationType, responseCatalogGender = _q.responseCatalogGender, loadingCatalogGender = _q.loadingCatalogGender;
    // Combined loading state
    var isLoading = loadingIdentificationType || loadingCatalogGender;
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFilters(newMap);
    }, [summary]);
    // Fetch identification types and genders on mount
    useEffect(function () {
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
    }, [dispatch, enable, page, limit, responseIdentificationType, responseCatalogGender]);
    // Process identification types
    useEffect(function () {
        var _a;
        if (responseIdentificationType && ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf = responseIdentificationType.data.map(function (item) { return ({
                id: item.id,
                name: item.description ? item.description : "",
                value: item.id,
            }); });
            console.log("Identification Types:", idf);
            setListIdentificationType(idf);
        }
    }, [responseIdentificationType]);
    // Process genders
    useEffect(function () {
        var _a;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data_1 = responseCatalogGender.data.map(function (gender) { return ({
                id: gender.id,
                value: gender.id,
                name: gender.description,
            }); });
            setListGenders(data_1);
        }
    }, [responseCatalogGender]);
    // Update editingPassengerData when external prop changes
    useEffect(function () {
        setEditingPassengerData(externalEditingData);
    }, [externalEditingData]);
    var handleSavePassenger = function (data) {
        console.log("Passenger data to save:", data);
        // Find identification type and gender names for display
        var idTypeObj = listIdentificationType.find(function (item) { return item.id === data.IdType; });
        var genderObj = listGenders.find(function (item) { return item.id === data.Gender; });
        var passengerData = __assign(__assign({}, data), { idTypeName: (idTypeObj === null || idTypeObj === void 0 ? void 0 : idTypeObj.name) || "", genderName: (genderObj === null || genderObj === void 0 ? void 0 : genderObj.name) || "" });
        console.log("Processed Passenger Data:", passengerData);
        if (onSavePassenger) {
            // onSavePassenger(passengerData);
            setPassengerList(function (prevList) { return __spreadArray(__spreadArray([], prevList, true), [passengerData], false); });
        }
        // Show success toast
        setSeeToast({
            show: true,
            message: "Pasajero guardado exitosamente",
            type: typeAlert.success,
        });
    };
    var handleCancel = function () {
        if (onCancel) {
            onCancel();
        }
        else {
            navigate(-1);
        }
    };
    var _r = useGetInformationSteps(pathLocation), instanceId = _r.instanceId, workFlowId = _r.workFlowId, currentStep = _r.currentStep, nextStep = _r.nextStep;
    var _s = useCompleteStep(), runComplete = _s.runComplete, loadingComplete = _s.loadingComplete, responseComplete = _s.responseComplete, errorComplete = _s.errorComplete;
    var handleSavePassengers = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var res, prevStep, currentStep_1, nextStep_1, err_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 1:
                    res = _e.sent();
                    if (res) {
                        updateStepByPath(pathname, { data: data });
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _e.sent();
                    setSeeToast({
                        show: true,
                        message: (_d = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _d !== void 0 ? _d : "Ocurrió un error al completar el paso.",
                        type: typeAlert.error,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handlePrevious = function () {
        console.log("Previous button clicked");
        backStepByPath(pathname);
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    var steps = useGetSteps();
    return (_jsxs(React.Fragment, { children: [_jsx(PassengerFormHeader, { loading: isLoading, seeToast: seeToast, setSeeToast: setSeeToast }), listIdentificationType.length > 0 && listGenders.length > 0 &&
                _jsx(PassengerFormView, { listGenders: listGenders, listIdentificationType: listIdentificationType, editingPassengerData: editingPassengerData, onSavePassenger: handleSavePassenger, onCancel: handleCancel, rangoEdad1Count: rangoEdad1Count, rangoEdad2Count: rangoEdad2Count, rangoEdad3Count: rangoEdad3Count, fechaSalida: fechaSalida, fechaRegreso: fechaRegreso, origen: origenViaje, destino: destinoViaje, totalPassengers: totalPassengers, filters: filters, passengerList: passengerList, onNext: function (data) { return handleSavePassengers(data); }, handlePrevious: function () { return handlePrevious(); } })] }));
};
export default PassengerForm;
